"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _botframeworkWebchatComponent = require("botframework-webchat-component");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _CommonCard = _interopRequireDefault(require("./CommonCard"));

var useStyleSet = _botframeworkWebchatComponent.hooks.useStyleSet;

var SignInCardAttachment = function SignInCardAttachment(_ref) {
  var attachment = _ref.attachment;

  var _useStyleSet = useStyleSet(),
      _useStyleSet2 = (0, _slicedToArray2.default)(_useStyleSet, 1),
      animationCardAttachmentStyleSet = _useStyleSet2[0].animationCardAttachment;

  return _react.default.createElement("div", {
    className: animationCardAttachmentStyleSet
  }, _react.default.createElement(_CommonCard.default, {
    attachment: attachment
  }));
};

SignInCardAttachment.propTypes = {
  attachment: _propTypes.default.any.isRequired
};
var _default = SignInCardAttachment;
exports.default = _default;